import clsx from "clsx";
import { ReactNode } from "react";
import { Link } from "react-router";
import css from "./Tabs.module.css";

export type TabSpec = {
  id: string;
  title: ReactNode;
  count?: number;
  body: () => ReactNode;
};

export type TabsProps = {
  current: string;
  link?: (id: string) => string;
  tabs: ReadonlyArray<TabSpec>;
};

export function Tabs(props: TabsProps) {
  if (props.tabs.length === 0) {
    return null;
  }

  const current =
    props.tabs.find((tab) => tab.id === props.current && tab.count !== 0) ??
    props.tabs[0];

  return (
    <div className={css.root}>
      <div className={css.head}>
        {props.tabs
          .filter((tab) => tab.count !== 0)
          .map((tab) => {
            return (
              <div key={tab.id}>
                <Link
                  to={props.link?.(tab.id) ?? ""}
                  className={clsx(
                    [css.tab],
                    tab.id === current.id && css.tabActive
                  )}
                  preventScrollReset={true}
                >
                  {tab.title}
                  {(tab.count || false) && ` (${tab.count})`}
                </Link>
              </div>
            );
          })}
      </div>
      {current.body()}
    </div>
  );
}
